module.exports = __webpack_public_path__ + "img/icon8-1.3fc9b547.svg";